"use strict";
import { COLORS } from "./chartColors";
export const applicationCountSourceTypeTransformer = (data, selectedEntities) => {
  const allRecords = [];
  Object.entries(data).forEach(([key, value]) => {
    const [entity_id] = key.split("_");
    const isAllSelected = selectedEntities == null ? void 0 : selectedEntities.some((entity) => entity.name === "All");
    const isEntitySelected = selectedEntities == null ? void 0 : selectedEntities.some(
      (entity) => entity.id.toString() === entity_id
    );
    if (selectedEntities && !isAllSelected && !isEntitySelected) {
      return;
    }
    if (Array.isArray(value.data)) {
      value.data.forEach((record) => {
        allRecords.push(record);
      });
    }
  });
  const sourceTypeCounts = {};
  allRecords.forEach((record) => {
    const type = record.source_type || "Unknown";
    sourceTypeCounts[type] = (sourceTypeCounts[type] || 0) + 1;
  });
  return {
    labels: Object.keys(sourceTypeCounts),
    datasets: [
      {
        data: Object.values(sourceTypeCounts),
        borderWidth: 1,
        backgroundColor: COLORS.slice(0, Object.keys(sourceTypeCounts).length)
      }
    ]
  };
};
